<div class="container">
    <div class="row">
        <div class="col-lg-12 py-3">
            <form [formGroup]="registerForm" class="col-sm-6" style="margin: 0 auto;">
                <p class="p-pos">Saját adatok</p>
                <p class="p-pos-down">Az alábbi adatokat tároljuk rólad, ha valamelyiket meg kívánod változtatni írd át.
                </p>
                <div class="mb-3">
                    <label class="form-label">Email cím<sup>*</sup></label>
                    <input formControlName="email" type="email" class="form-control" [(ngModel)]="emailModel">
                    <div *ngIf="(registerForm.get('email')?.errors?.['email'] || registerForm.get('email')?.errors?.['required']) && (registerForm.get('email')?.dirty || registerForm.get('email')?.touched)"
                        class="error-message">
                        Adj meg érvényes email címet!
                    </div>
                </div>
                <div class="mb-3">
                    <label class="form-label">Hogyan szólítsunk<sup>*</sup></label>
                    <input formControlName="display_name" type="text" class="form-control"
                        [(ngModel)]="display_nameModel">
                    <div *ngIf="registerForm.get('display_name')?.errors?.['required'] && (registerForm.get('display_name')?.dirty || registerForm.get('display_name')?.touched)"
                        class="error-message">
                        Kötelező mező!
                    </div>
                </div>
                <div class="mb-3">
                    <label class="form-label">Vezetéknév<sup>*</sup></label>
                    <input formControlName="last_name" type="text" class="form-control" [(ngModel)]="last_nameModel">
                    <div *ngIf="registerForm.get('last_name')?.errors?.['required'] && (registerForm.get('last_name')?.dirty || registerForm.get('last_name')?.touched)"
                        class="error-message">
                        Kötelező mező!
                    </div>
                </div>
                <div class="mb-3">
                    <label class="form-label">Keresztnév<sup>*</sup></label>
                    <input formControlName="first_name" type="text" class="form-control" [(ngModel)]="first_nameModel">
                    <div *ngIf="registerForm.get('first_name')?.errors?.['required'] && (registerForm.get('first_name')?.dirty || registerForm.get('first_name')?.touched)"
                    class="error-message">
                    Kötelező mező!
                </div>
                </div>
                <div class="mb-3">
                    <label class="form-label">Születési év<sup>*</sup></label>
                    <input formControlName="birthdate" type="number" class="form-control" [(ngModel)]="birthdateModel">
                    <div *ngIf="registerForm.get('birthdate')?.errors?.['required'] && (registerForm.get('birthdate')?.dirty || registerForm.get('birthdate')?.touched)"
                    class="error-message">
                    Kötelező mező!
                </div>
                </div>
                <div class="mb-3">
                  <label class="form-label">Ország</label>
                  <select formControlName="country" class="form-select form-control" [(ngModel)]="countryModel">
                    <option *ngFor="let country of countryAvailable" [value]="country.code">{{country.name}}</option>
                  </select>
              </div>
                <div class="mb-3">
                    <label class="form-label">Irányítószám</label>
                    <input formControlName="postcode" type="text" class="form-control" [(ngModel)]="postcodeModel">
                    <div *ngIf="registerForm.get('postcode')?.errors?.['pattern'] && (registerForm.get('postcode')?.dirty || registerForm.get('postcode')?.touched)"
                        class="error-message">
                        Adj meg érvényes irányitószámot (pl: 1111)!
                    </div>
                </div>
                <div class="mb-3">
                    <label class="form-label">Város</label>
                    <input formControlName="city" type="text" class="form-control" [(ngModel)]="cityModel">
                </div>
                <div class="mb-3">
                    <label class="form-label">Utca</label>
                    <input formControlName="street" type="text" class="form-control" [(ngModel)]="streetModel">
                </div>
                <div class="mb-3">
                    <label class="form-label">Házszám</label>
                    <input formControlName="snumber" type="text" class="form-control" [(ngModel)]="snumberModel">
                </div>
                <div class="mb-3" *ngIf="loginError && showLoginAlert">
                    <p class="alert alert-danger">{{loginError}}</p>
                </div>
                <div class="d-flex justify-content-center">
                    <button type="button" class="btn btn-primary c" (click)="onSubmit()">Módosítás</button>
                </div>
            </form>
            <form [formGroup]="passwordChangeForm" class="col-sm-6" style="margin: 0 auto;">
              <p class="p-pos mt-3">Jelszó módosítás</p>
              <div class="mb-3">
                <label class="form-label">Jelenlegi jelszó<sup>*</sup></label>

                <div class="d-flex gap-2 align-items-center">
                  <input formControlName="password" type="password" class="form-control" #password>
                  <i class="bi bi-eye-slash" #togglePasswordIcon (click)="togglePassword()"></i>
                </div>
                <div *ngIf="passwordChangeForm.get('password')?.errors?.['required'] && (passwordChangeForm.get('password')?.dirty || passwordChangeForm.get('password')?.touched)"
                    class="error-message">
                    Jelszó megadása kötelező
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label">Új jelszó<sup>*</sup></label>
                <div class="d-flex gap-2 align-items-center">
                  <input formControlName="newPassword" type="password" #newPassword class="form-control" required
                    (input)="onPasswordInput()">
                    <i class="bi bi-eye-slash" #toggleNewPasswordIcon (click)="toggleNewPassword()"></i>
                </div>
                <div class="info-message">
                    A jelszónak legalább 8 karakter hosszúnak kell lennie, és tartalmaznia kell legalább egy speciális karaktert.
                </div>
                <div *ngIf="passwordChangeForm.get('newPassword')?.errors?.['required'] && (passwordChangeForm.get('newPassword')?.dirty || passwordChangeForm.get('newPassword')?.touched)"
                    class="error-message">
                    Jelszó megadása kötelező!
                </div>
                <div *ngIf="passwordChangeForm.get('newPassword')?.errors?.['pattern'] && (passwordChangeForm.get('newPassword')?.dirty || passwordChangeForm.get('newPassword')?.touched)"
                    class="error-message">
                    A jelszó nem felel meg a követelményeknek!
                </div>
            </div>
            <div class="mb-3">
                <label class="form-label">Új jelszó mégegyszer<sup>*</sup></label>
                <div class="d-flex gap-2 align-items-center">
                  <input formControlName="passwordAccept" #passwordAccept type="password" class="form-control">
                    <i class="bi bi-eye-slash" #togglePasswordConfirmIcon (click)="togglePasswordConfirm()"></i>
                </div>

                <div *ngIf="passwordChangeForm.get('passwordAccept')?.errors?.['required'] && (passwordChangeForm.get('passwordAccept')?.dirty || passwordChangeForm.get('passwordAccept')?.touched)"
                    class="error-message">
                    Jelszó megadása mégegyszer kötelező!
                </div>
                <div *ngIf="passwordChangeForm.hasError('passwordMismatch')" class="error-message">
                    Jelszavak nem egyeznek meg.
                </div>
              </div>

                <div class="d-flex justify-content-center">
                  <button type="button" class="btn btn-primary c" (click)="onSubmitPass()" [disabled]="passwordSubmitDisabled">Módosítás</button>
              </div>
            </form>
            <p class="p-pos mt-3">Fiók törlése</p>
            <div class="d-flex justify-content-center">
              <button type="button" class="btn btn-secondary" (click)="onDeleteProfile()">Fiók törlése</button>
          </div>
        </div>
    </div>
    <div class="overlay" *ngIf="showModal"></div>
    <div class="modal fade modalc" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
        id="exampleModal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form>
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">{{ modalTitle }}</h5>
                        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"
                            (click)="closeModal()">
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>{{ modalContent }}</div>
                    </div>

                    <div class="modal-footer" *ngIf="platform !== 'delete-profile'">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal"
                            (click)="closeModal()">Bezárás</button>
                    </div>
                    <div class="modal-footer" style="display:flex; justify-content: space-around;" *ngIf="platform == 'delete-profile'">
                      <button type="button" class="btn btn-primary c"
                          (click)="doModalAction()">{{ modalActionTitle }}</button>
                      <button type="button" class="btn btn-secondary" data-dismiss="modal"
                          (click)="closeModal()"> {{ modalCancelTitle }}</button>
                  </div>
                </form>
            </div>
        </div>
    </div>
</div>
